import classNames from "classnames"
import Action from "components/Action"
import style from "components/ContentPanel.module.scss"
import { motion } from "framer-motion"
import Img from "gatsby-image"
import { useStores } from "hooks/useStores"
import {
  childVariants,
  contentVariants,
  highlightVariants,
  imageVariants,
  rootVariants
} from "lib/constants"
import { formatMarkdown } from "lib/helpers"
import camelCase from "lodash/camelCase"
import { observer } from "mobx-react"
import React from "react"
import { useInView } from "react-intersection-observer"

const ContentPanel = ({
  image,
  heading,
  imagePosition,
  color,
  text,
  action
}) => {
  const { uiStore } = useStores()

  const { ref, inView, entry } = useInView({
    triggerOnce: true,
    threshold: 0.5
  })

  const imageType = uiStore.isSmallerThanDesktop ? "mobile" : "desktop"

  const fluid = imageType === "mobile" ? image.mobile : image.desktop

  const className = classNames(
    style.root,
    style[`root___highlightColor_${camelCase(color)}`],
    style[`root___imagePosition_${camelCase(imagePosition)}`]
  )

  return (
    <motion.div
      className={className}
      ref={ref}
      variants={rootVariants}
      initial="initial"
      animate={inView ? "animate" : "initial"}
      exit="exit"
    >
      <div className={style.content} variants={contentVariants}>
        <div className={style.panels}>
          <motion.div
            className={style.highlight}
            variants={highlightVariants}
          />
          <div className={style.image} variants={imageVariants}>
            <div className={style.img}>
              {!!image && (
                <Img
                  placeholderStyle={{ visibility: "hidden" }}
                  fluid={fluid}
                />
              )}
            </div>
          </div>
          <div className={style.textWrapper} variants={childVariants}>
            <div className={style.text}>
              <h3 className={style.heading}>{heading}</h3>
              <div
                className={style.body}
                dangerouslySetInnerHTML={{ __html: formatMarkdown(text) }}
              />
              {(!!action.url || !!action.label) && (
                <div className={style.action}>
                  <Action
                    url={action.url}
                    label={action.label}
                    backgroundColor="white"
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default observer(ContentPanel)
